module.exports = __webpack_public_path__ + "static/waiter-job-description-b099f3f420bf4336aa3c367c14dc9a1f.jpeg";